import { get, post, put, delete_ } from ".";

export const getAllRegions = () => {
  return get(`/api/region/manage/myCartableAreas`, true);
};
export const getAllUserArea = () => {
  return get(`/api/region/manage_user/list`, true);
};
export const getUserInArea = (areaId) => {
  return get(`/api/region/manage_user/members/${areaId}`, true);
};
export const getAllModules = () => {
  return get(`/api/region/module/getAllModules`, true);
};
export const getModulesInArea = (areaId) => {
  return get(`/api/region/module/getModulesInArea/${areaId}`, true);
};
export const getgetDispatchers = (areaId) => {
  return get(`/api/region/manage_user/getDispatchers/${areaId}`, true);
};
export const getTrainers = (areaId) => {
  return get(`/api/region/manage_user/getTrainers/${areaId}`, true);
};
export const getInsurancers = (areaId) => {
  return get(`/api/region/manage_user/getInsurancers/${areaId}`, true);
};
export const getPharmacyManagers = (areaId) => {
  return get(`/api/region/manage_user/getPharmacyManagers/${areaId}`, true);
};
export const getEquipmentManagers = (areaId) => {
  return get(`/api/region/manage_user/getEquipmentManagers/${areaId}`, true);
};
export const getCountries = () => {
  return get(`/api/public/getCountries`, true);
};
export const getStates = (countryId) => {
  return get(`/api/public/getStates/${countryId}`, true);
};
export const getCities = (stateId) => {
  return get(`/api/public/getCities/${stateId}`, true);
};
export const getDashboardArea = (areaId) => {
  return get(`/api/region/manage/dashboard/${areaId}`, true);
};
export const getDrugListInArea = (areaId) => {
  return get(`/api/region/drug/list/${areaId}`, true);
};
export const getEquipmentListInArea = (areaId) => {
  return get(`/api/region/equipment/list/${areaId}`, true);
};
export const getPatients = (areaId) => {
  return get(`/api/region/patient/getPatients/${areaId}`, true);
};
export const getPresenceList = (areaId) => {
  return get(`/api/region/manage/getPresenceList/${areaId}`, true);
};
export const getDrugUseTimeOptions = () => {
  return get(`/api/public/getDrugUseTimeOptions`, true);
};
export const getDrugHowToUseOptions = () => {
  return get(`/api/public/getDrugHowToUseOptions`, true);
};
export const getAllDrugBookmark = () => {
  return get(`/api/jahadgar/drug/bookmarks`, true);
};
export const getDrugAmountOfUseOptions = () => {
  return get(`/api/public/getDrugAmountOfUseOptions`, true);
};
export const getTrainList = (areaId, filter) => {
  return get(
    `/api/region/patient/getTrainList/${areaId}${filter ? filter : ""}`,
    true
  );
};
export const getExperimentInArea = () => {
  return get(`/api/region/experiment/list`, true);
};
export const getListOfAdvices = (areaId, filter) => {
  return get(
    `/api/jahadgar/drug/listOfAdvices/${areaId}?pageNo=1${filter}`,
    true
  );
};

export const getModulePatients = (areaId, moduleId, filter) => {
  return get(
    `/api/region/patient/getModulePatients/${areaId}/${moduleId}${
      filter ? filter : ""
    }`,
    true
  );
};
export const getInsurerList = (areaId, filter) => {
  return get(
    `/api/region/patient/getInsuranceList/${areaId}${filter ? filter : ""}`,
    true
  );
};
export const getPatientTrainFrom = (areaId, patientId) => {
  return get(
    `/api/region/patient/getPatientTrainFrom/${areaId}/${patientId}`,
    true
  );
};

export const getHistoryTimeArea = (areaId) => {
  return get(`/api/region/manage/getRegionTimesHistory/${areaId}`, true);
};
export const getPatientReferrals = (areaId, patientId) => {
  return get(
    `/api/region/patient/getPatientReferrals/${areaId}/${patientId}`,
    true
  );
};
export const getSubModuleInArea = (areaId, moduleId) => {
  return get(`/api/region/module/getModuleInArea/${areaId}/${moduleId}`, true);
};
export const getDrugsInArea = (areaId) => {
  return get(`/api/drug/list/${areaId}`, true);
};
export const getManage_user = (areaId) => {
  return get(`/api/region/manage_user/members/${areaId}`, true);
};
export const getModuleNameInArea = (areaId) => {
  return get(`/api/region/module/getTabsInArea/${areaId}`, true);
};
export const getModulesInTab = (areaId, moduleName) => {
  return get(
    `api/region/module/getModulesInTab/${areaId}?tabName=${moduleName}`,
    true
  );
};
export const getPatientForm = (areaId, moduleId, subModuleId, patientId) => {
  return get(
    `/api/region/patient/getPatientForm/${areaId}/${moduleId}/${subModuleId}/${patientId}`,
    true
  );
};
export const getQuestionModule = (areaId, moduleId, subModuleId) => {
  return get(
    `/api/region/module/getSubModule/${areaId}/${moduleId}/${subModuleId}`,
    true
  );
};
export const getRunInfoArea = (areaId) => {
  return get(`/api/region/manage/getRunInfo/${areaId}`, true);
};

export const getExperiments = (areaId, moduleId, patientId) => {
  return get(
    `/api/region/experiment/getExperiments/${areaId}/${moduleId}/${patientId}`,
    true
  );
};
export const getAllExperimentsOfPatient = (areaId, patientId) => {
  return get(
    `/api/region/experiment/getAllExperimentsOfPatient/${areaId}/${patientId}`,
    true
  );
};
export const putRunInfo = (areaId, data) => {
  return put(`/api/region/manage/setRunInfo/${areaId}`, true, data);
};
export const setPatientTrainFrom = (areaId, patientId, data) => {
  return put(
    `/api/region/patient/setPatientTrainFrom/${areaId}/${patientId}`,
    true,
    data
  );
};
export const putAddDispatcher = (areaId, data) => {
  return put(`/api/region/manage_user/addDispatcher/${areaId}`, true, data);
};
export const putAddReferralForPatientByOwner = (
  areaId,
  moduleId,
  patientId
) => {
  return put(
    `/api/region/patient/addReferralForPatientByOwner/${areaId}/${patientId}/${moduleId}`,
    true
  );
};
export const putAddMujahidArea = (areaId, data) => {
  return put(`/api/region/manage_user/addMembers/${areaId}`, true, data);
};
export const putAddModuleArea = (areaId, data) => {
  return put(`/api/region/module/setModules/${areaId}`, true, data);
};
export const putSubmitEntrance = (userId, areaId) => {
  return put(`/api/region/manage/submitEntrance/${userId}/${areaId}`, true);
};
export const putFinalize = (areaId) => {
  return put(`/api/region/manage/finalize/${areaId}`, true);
};
export const putStartRegionTime = (areaId) => {
  return put(`/api/region/manage/setStartRegionTime/${areaId}`, true);
};
export const putEndRegionTime = (areaId) => {
  return put(`/api/region/manage/setEndRegionTime/${areaId}`, true);
};
export const bookmarkDrug = (drugId, data) => {
  return put(`/api/jahadgar/drug/bookmark/${drugId}`, true, data);
};
export const putAddPatient = (areaId, data) => {
  return put(
    `/api/region/patient/createPatientAndAddToRegion/${areaId}`,
    true,
    data
  );
};
export const putAddUesersModule = (areaId, moduleIdInArea, data) => {
  return put(
    `/api/region/module/addMembersToModule/${areaId}/${moduleIdInArea}`,
    true,
    data
  );
};
// export const putReceptionStatusOfPatient = (areaId, moduleIdInArea, data) => {
//   return put(
//     `/api/region/patient/setReceptionStatusOfPatient/${areaId}/${moduleId}/${patientId}`,
//     true,
//     data
//   );
// };
export const setPatientTrainStatus = (areaId, patientId, hasTrained) => {
  return put(
    `/api/region/patient/setPatientTrainStatus/${areaId}/${patientId}?hasTrained=${hasTrained}`,
    true
  );
};
export const setPatientInsuranceStatus = (areaId, patientId, filter) => {
  return put(
    `/api/region/patient/setPatientInsuranceStatus/${areaId}/${patientId}${
      filter ? filter : ""
    }`,
    true
  );
};
export const putAddSecretariesModule = (areaId, moduleIdInArea, data) => {
  return put(
    `/api/region/module/addSecretariesToModule/${areaId}/${moduleIdInArea}`,
    true,
    data
  );
};
export const putUpdatePresenceList = (userId, areaId, presenceListId, data) => {
  return put(
    `/api/region/manage/updatePresenceList/${userId}/${areaId}/${presenceListId}`,
    true,
    data
  );
};
export const putAddTrainer = (areaId, data) => {
  return put(`/api/region/manage_user/addTrainer/${areaId}`, true, data);
};
export const giveDrugToPatient = (areaId, adviceId, data) => {
  return put(
    `/api/jahadgar/drug/giveDrugToPatient/${areaId}/${adviceId}`,
    true,
    data
  );
};
export const putAddDrugInArea = (areaId, data) => {
  return put(`/api/jahadgar/drug/addAllToDrugsList/${areaId}`, true, data);
};
export const putAddEquipmentInArea = (areaId, data) => {
  return put(
    `/api/jahadgar/equipment/addAllEquipmentsToArea/${areaId}`,
    true,
    data
  );
};
export const putAddInsurancer = (areaId, data) => {
  return put(`/api/region/manage_user/addInsurancer/${areaId}`, true, data);
};
export const addPharmacyManager = (areaId, data) => {
  return put(
    `/api/region/manage_user/addPharmacyManager/${areaId}`,
    true,
    data
  );
};
export const addEquipmentManager = (areaId, data) => {
  return put(
    `/api/region/manage_user/addEquipmentManager/${areaId}`,
    true,
    data
  );
};
export const returnAllDrugs = (areaId) => {
  return put(`/api/region/drug/returnAllDrugs/${areaId}`, true);
};
export const returnAllEquipments = (areaId) => {
  return put(`/api/region/equipment/returnAllEquipments/${areaId}`, true);
};

export const addReferralForPatient = (areaId, moduleId, patientId, data) => {
  return put(
    `/api/region/patient/addReferralForPatient/${areaId}/${moduleId}/${patientId}`,
    true,
    data
  );
};
export const sendTripAlarmToAllMembers = (areaId, data) => {
  return post(
    `/api/region/manage/sendTripAlarmToAllMembers/${areaId}`,
    true,
    data
  );
};
export const setReceptionStatusOfPatient = (
  areaId,
  moduleId,
  patientId,
  isRecepted
) => {
  return put(
    `/api/region/patient/setReceptionStatusOfPatient/${areaId}/${moduleId}/${patientId}?isRecepted=${isRecepted}
    `,
    true
  );
};
export const addReferralForPatientBySubModule = (
  areaId,
  moduleId,
  subModuleId,
  patientId
) => {
  return put(
    `/api/region/patient/addReferralForPatientBySubModule/${areaId}/${moduleId}/${subModuleId}/${patientId}
    `,
    true
  );
};
export const setPatientForm = (
  areaId,
  moduleId,
  subModuleId,
  patientId,
  data,
  body
) => {
  return put(
    `/api/region/patient/setPatientForm/${areaId}/${moduleId}/${subModuleId}/${patientId}?forms=${data}
    `,
    true,
    body
    // {
    //   "content-type": "multipart/form-data",
    //   "Access-Control-Allow-Origin": "*/*",
    // }
  );
};
export const inquiryPatient = (areaId, data) => {
  return post(`/api/region/patient/inquiryPatient/${areaId}`, true, data);
};
export const suggestExperiment = (areaId, moduleId, patientId, data) => {
  return post(
    `/api/region/experiment/suggestExperiment/${areaId}/${moduleId}/${patientId}`,
    true,
    data
  );
};
export const postAdvice = (patientId, moduleId, areaDrugId, data) => {
  return post(
    `/api/jahadgar/drug/advice/${patientId}/${moduleId}/${areaDrugId}`,
    true,
    data
  );
};
export const postAdvice1 = (patientId, areaDrugId, data) => {
  return post(
    `/api/jahadgar/drug/advice/${patientId}/${areaDrugId}`,
    true,
    data
  );
};
export const addPatientToRegion2 = (areaId, patientId) => {
  return put(
    `/api/region/patient/addPatientToRegion/${areaId}/${patientId}`,
    true
  );
};
export const _deleteUserFromArea = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removeMember/${areaId}/${userId}`,
    true
  );
};
export const removeTrainer = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removeTrainer/${areaId}/${userId}`,
    true
  );
};
export const removeDispatcher = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removeDispatcher/${areaId}/${userId}`,
    true
  );
};
export const removeInsurancer = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removeInsurancer/${areaId}/${userId}`,
    true
  );
};
export const removePharmacyManager = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removePharmacyManager/${areaId}/${userId}`,
    true
  );
};
export const removeEquipmentManager = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removeEquipmentManager/${areaId}/${userId}`,
    true
  );
};
export const removeExperiment = (areaId, moduleId, patientId, experimentId) => {
  return delete_(
    `/api/region/experiment/removeExperiment/${areaId}/${moduleId}/${patientId}/${experimentId}`,
    true
  );
};

export const removeAdvice = (adviceId) => {
  return delete_(`/api/jahadgar/drug/removeAdvice/${adviceId}`, true);
};
export const removeDrugInBookmark = (drugId) => {
  return delete_(`/api/jahadgar/drug/bookmark/${drugId}`, true);
};
